import router from "@/router";
import res1 from "~/auth/dian.js";
import res2 from "~/auth/jian.js";
import res3 from "~/auth/zhuan.js";
import res4 from "~/auth/user.js";

export default {
  namespaced: true,
  state: {
    menus: [],
  },
  mutations: {
    SET_MENU(state, payload) {
      state.menus = payload;

      router.addRoutes(payload);
    },

    DELETE_MENU(state) {
      state.menus = [];
    },
  },
  actions: {
    async FETCH_MENUS(context) {
      switch (sessionStorage.getItem("role")) {
        case "2":
          context.commit("SET_MENU", res1.data);
          break;
        case "3":
          context.commit("SET_MENU", res2.data);
          break;
        case "4":
          context.commit("SET_MENU", res3.data);
          break;
        case "5":
          context.commit("SET_MENU", res4.data);
          break;
      }
    },
  },
};
